<template>
  <div class="relative mb-4">
    <label :for="setting.name">
      {{ setting.label }}
    </label>

    <SettingsMessage v-if="setting.message" :message="setting.message" />

    <Loader v-if="saving" label="" class="loading-icon" />

    <input
      :name="setting.name"
      type="number"
      :value="setting.numberValue"
      :min="setting.min"
      :max="setting.max"
      :disabled="saving"
      @blur="onBlur"
    />
  </div>
</template>

<script>
import clone from "just-clone";
import SettingsMessage from "./SettingsMessage";
import Loader from "@/components/UI/Loader";

export default {
  name: "NumberSetting",
  components: {
    Loader,
    SettingsMessage
  },
  props: {
    setting: {
      type: Object,
      required: true,
      id: {
        required: true,
        type: String
      },
      name: {
        required: true,
        type: String
      },
      label: {
        required: true,
        type: String
      },
      numberValue: Number,
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 99999999999
      }
    },
    saving: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    displayInvalidAlert(value) {
      let text = "";

      if (value < this.setting.min) {
        text = `Please add a number greater than ${this.setting.min}`;
      }

      if (value > this.setting.max) {
        text = `Please add a number less than ${this.setting.max}`;
      }

      if (text) {
        this.$modal.show("dialog", {
          title: "Ot oh 😮",
          text,
          buttons: [
            {
              title: "Close"
            }
          ]
        });
      }
    },
    isValid(value) {
      return value >= this.setting.min && value <= this.setting.max;
    },
    onBlur(event) {
      const { value } = event.target;

      if (this.isValid(value)) {
        const setting = clone(this.setting);
        setting.numberValue = value;
        this.$emit("setting-updated", setting, value);
      } else {
        // Let the user know their input was invalid...
        this.displayInvalidAlert(value);
        // Force an update to reset the inputs value...
        this.$forceUpdate();
        // Prevent the default blur event from bubbling up...
        event.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
.loading-icon {
  @apply absolute p-0;
  font-size: 0.6rem;
  right: 15px;
  top: 60px;
  z-index: 1;
}
</style>
